import Vue from 'vue';
import base64 from 'js-base64';
import cookie from 'js-cookie';
import StateHandler from '../base/StateHandler';
import PlatformConst from '../base/PlatformConst';
import AnalyticsPublic from '../base/AnalyticsPublic';

export default new Vue({
  data() {
    return {
      lang: '',
      headerNavShown: {
        dashboard: false,
        gameReport: false,
        analytics: false,
        push: false,
        helper: false,
        manage: false,
      },
      productid: 0,
      // 默认时间为最近一个月
      selectedDate: [this.getDay(-30), this.getDay(0)],
      qualitySelectedDate: [this.getDay(-32), this.getDay(-2)],
      productInfo: {},
      platform: [],
      developerid: '',
      userReg: '',
      // 选中的筛选条件
      conditions: {
        partner: [],
        usergroup: [],
        version: [],
        newUserGroup: [],
      },
      token: '',
      username: '',
      authorinfo: {},
      // 对不支持sessionStorage的浏览器，代替sessionstorage存储数据
      sessionStorage: {},
      isAllPlatform: true, // 是否为全平台，默认情况是全平台，为true
    };
  },
  computed: {
    appkey() {
      const sequencenumber = StateHandler.store.state.productObj.sequencenumber;
      const keys = Object.keys(sequencenumber);
      const appKey = sequencenumber[keys[0]];
      return appKey;
    },
  },
  methods: {
    changeProduct(paramObj) {
      this.productid = '' + paramObj.productid;
      this.productInfo = paramObj;
      this.platform = paramObj.platform;
      this.$emit('on-app-change');
      this.$emit('on-app-change-nav');
      this.resetAllPlatform();
    },
    changePlatform(paramObj) {
      this.platform = paramObj;
      this.updateAllPlatform();
      this.$emit('on-platform-change');
      this.$emit('on-platform-change-nav');
    },
    changeDate(paramObj) {
      this.selectedDate = paramObj;
      this.$emit('on-date-change');
    },
    changeCondition(paramObj) {
      this.conditions = paramObj;
      this.$emit('on-conditions-change');
    },
    changeQualityDate(paramObj) {
      this.qualitySelectedDate = paramObj;
      this.$emit('on-date-change');
    },
    /**
     * 获取日期
     * @param days {Number} 距今天天数
     **/
    getDay(days) {
      const today = new Date().valueOf();
      const selday = new Date(today + (days * 3600 * 1000 * 24));
      const year = selday.getFullYear();
      const month = selday.getMonth() >= 9 ? selday.getMonth() + 1 : `0${(selday.getMonth() + 1)}`;
      const day = selday.getDate() >= 10 ? selday.getDate() : `0${selday.getDate()}`;
      return `${year}-${month}-${day}`;
    },
    /* base64 */
    setEncode(str) {
      const addBase = 'TGHsge==IuPAVC';
      return base64.Base64.encode(str) + addBase;
    },
    getToken() {
      this.token = cookie.get('_app_token_');
      window.TOKENID = this.token;
    },
    /* demo 不允许操作提示 */
    demoTip() {
      const tip = this.lang === 'zh-CN' ? 'Demo数据，无法操作' : 'Demo can not be changed';
      if (this.$demo) {
        this.$Message.info(tip, 3);
        return true;
      }
      return false;
    },
    /**
     * [生成表格下载名称]
     * @param  {[type]} name [当前表格名称]
     * @return {[type]}      [description]
     */
    getDownloadName(name) {
      // 日期
      const time = `${this.selectedDate[0]}_${this.selectedDate[1]}`;
      // 平台
      const platForm = this.platform.map(x =>
       PlatformConst.platform[x].name.slice(0, 3).toUpperCase()).join('-');
      const filename = `${name}_${time}_${platForm}_${this.productInfo.productname}`;

      return filename.slice(0, 127);
    },
    updateAllPlatform() {
      this.isAllPlatform = AnalyticsPublic.platform.sort().toString() === AnalyticsPublic.platformFull.sort().toString();
    },
    resetAllPlatform() {
      this.isAllPlatform = true;
    }
  },
  created() {
    this.getToken();
  },
});
